import React, { useState } from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { AI_FEEDBACK_TYPES, AIFeedbackFeatureType, AIFeedbackType } from './constants';
import FeedbackModal from './FeedbackModal';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 12px;
  color: var(--text-secondary);
`;

const Item = styled.div`
  display: flex;
  flex-flow: row;
  gap: 3px;
  align-items: center;
  cursor: pointer;
  color: var(--text-secondary);

  &.active {
    color: var(--active-blue);
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

const IconBox = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  background: transparent;
`;

const Label = styled.span`
  display: inline-flex;
  align-items: center;
  padding-top: 2px;
  font-size: 12px;
`;

type Props = {
  subtitle: string;
  featureType: AIFeedbackFeatureType;
  recommendationOverview?: number | null;
  actionPlan?: number | null;
  cmiDigestRunCommunity?: number | null;
  community?: number | null;
  sourceUrl?: string;
  existingFeedback?: any;
};

const Feedback = ({
  subtitle,
  featureType,
  recommendationOverview,
  actionPlan,
  cmiDigestRunCommunity,
  community,
  sourceUrl,
  existingFeedback,
}: Props) => {
  const [mode, setMode] = useState<AIFeedbackType | null>(null);
  const isHelpfulActive = existingFeedback?.feedback_type === AI_FEEDBACK_TYPES.HELPFUL;
  const isNotHelpfulActive = existingFeedback?.feedback_type === AI_FEEDBACK_TYPES.NOT_HELPFUL;

  return (
    <>
      <Container>
        <Item
          className={classNames({ active: isHelpfulActive, disabled: isNotHelpfulActive })}
          onClick={() => !isNotHelpfulActive && setMode(AI_FEEDBACK_TYPES.HELPFUL)}
        >
          <IconBox>
            <img
              src={isHelpfulActive ? '/icons/sentiment-satisfied-blue.svg' : '/icons/sentiment-satisfied-gray.svg'}
              width="15"
              height="15"
              alt=""
            />
          </IconBox>
          <Label>Helpful</Label>
        </Item>
        <Item
          className={classNames({ active: isNotHelpfulActive, disabled: isHelpfulActive })}
          onClick={() => !isHelpfulActive && setMode(AI_FEEDBACK_TYPES.NOT_HELPFUL)}
        >
          <IconBox>
            <img
              src={
                isNotHelpfulActive ? '/icons/sentiment-dissatisfied-blue.svg' : '/icons/sentiment-dissatisfied-gray.svg'
              }
              width="15"
              height="15"
              alt=""
            />
          </IconBox>
          <Label>Not helpful</Label>
        </Item>
      </Container>
      {mode && (
        <FeedbackModal
          mode={mode}
          subtitle={subtitle}
          featureType={featureType}
          recommendationOverview={recommendationOverview}
          actionPlan={actionPlan}
          cmiDigestRunCommunity={cmiDigestRunCommunity}
          community={community}
          sourceUrl={sourceUrl}
          existingFeedback={existingFeedback}
          onClose={() => setMode(null)}
        />
      )}
    </>
  );
};

export default Feedback;
